// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"LoadingSpinner_loadingSpinner__RhjXu","loadingspin":"LoadingSpinner_loadingspin__clLN4"};